import { Component, Input, Output, EventEmitter, HostBinding, SimpleChanges, OnChanges } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SharingService, ReportingService } from '../../services';
import { SharePlatform } from '../../services/sharing.service';
import { ClickOutsideDirective } from '../../directives';

@Component({
  selector: 'share-menu',
  templateUrl: 'share-menu.component.html',
  styleUrls: ['./share-menu.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({
        opacity: 1
      })),
      state('out', style({
        opacity: 0
      })),
      transition('out => in', animate('200ms ease-in-out')),
      transition('in => out', animate('200ms 800ms ease-in-out'))
    ]),
  ]
})
export class ShareMenuComponent implements OnChanges {

  // The job being shared
  @Input() job: object;

  // Whether or not to use the modal version of the menu
  @Input() modal: boolean = false;

  // If true, menu goes up, otherwise down
  @Input() openUp: boolean = false;

  // Pass up the fact that a share was clicked
  @Output() shareClicked: EventEmitter<boolean> = new EventEmitter();

  // Host binding for dynamically adding classes
  @HostBinding('class') hostClass;

  // Bindings for template to use
  sharePlatformFacebook = SharePlatform.Facebook;
  sharePlatformTwitter = SharePlatform.Twitter;
  sharePlatformLinkedIn = SharePlatform.LinkedIn;
  sharePlatformEmail = SharePlatform.Email;
  sharePlatformCopyLink = SharePlatform.CopyLink;

  // The state for the copy success message - either in or out
  public copyState: string = 'out';

  constructor(
    private sharingService: SharingService,
    private reportingService: ReportingService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.modal) {
      this.hostClass = changes.modal.currentValue ? 'share-type-modal' : 'share-type-list';

      if (this.openUp && !changes.modal.currentValue) {
        this.hostClass = 'share-type-list share-list-direction-up';
      }
    }
  }

  /**
   * Shares the current job with a given platform
   * @param { Event } event - Click event, if any
   * @param { SharePlatform } platform - Platform which to share the job on
   */
  handleClick(event: Event, platform: SharePlatform) {
    if (event) event.stopPropagation();
    this.reportingService.trackCustomEvent('cp_share_' + platform.toLowerCase());
    this.sharingService.share(platform, this.job);
    if (platform === this.sharePlatformCopyLink) {
      this.copyState = 'in';
    }
    this.shareClicked.emit(true);
  }

  /**
   * Toggles the display of the link copy confirmation
   */

  toggleCopyState(){
    this.copyState = 'out';
  }


}
